<template>
	<div>
		<el-table v-loading="loading" :data="tableData" height="450">
			<el-table-column type="index" label="序号" width="50"> </el-table-column>
			<el-table-column prop="name" label="产品名称"> </el-table-column>
			<el-table-column prop="grade" label="产品等级" width="80">
				<template slot-scope="scope">
					<span v-text="getLevelName(scope.row.grade)"></span>
				</template>
			</el-table-column>
			<el-table-column prop="created_time" label="创建日期" width="180">
				<template slot-scope="scope">
					<span v-text="timeStampFormat(scope.row.created_time)"></span>
				</template>
			</el-table-column>
			<el-table-column label="选择" width="100">
				<template slot-scope="scope">
					<el-button type="text" size="medium" v-if="scope.row._id.$oid == product_id" :disabled="true">已关联</el-button>
					<el-button type="text" size="medium" v-else @click="select(scope.row)">选择</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	import { formatDate, formatExcelDateTime } from '@/util/datetime'
	import { productRequest } from '@/network/requests/product'
	import { stringToBlob } from '@/util/stringToPlainTextBlob'
	import { ProductLevel } from '@/components/Product'
	export default {
		data() {
			return {
				tableData: [],
				pageCount: 1,
				pageSize: 10,
				pageIndex: 1,
				loading: false,
			}
		},
		props: {
			product_id: {
				type: String,
			},
		},
		methods: {
			/**
			 * timeStamp格式化。
			 */
			timeStampFormat(timeStamp) {
				return formatDate(timeStamp)
			},
			select(row) {
				this.$emit('selectProduct', row)
			},
			/**
			 * 获取产品等级名称。
			 */
			getLevelName(value) {
				return ProductLevel.getLevelName(value)
			},
		},
		created() {
			this.loading = true
			productRequest
				.queryAll()
				.then(res => {
					this.tableData = res
				})
				.finally(() => {
					this.loading = false
				})
		},
	}
</script>

<style></style>
